import * as React from "react";
import PeopleIconSVG  from '../assests/icons/peopleIcon.svg'

const PeopleIcon = (props) => (
  <img alt="Logo" src={PeopleIconSVG} {...props} />

);

export default PeopleIcon;
